import axios from 'axios'
import pkg from '../../package'
import { setPreload, getPreload } from '../cache'
import { convertRequestURL, appendRequestData, stringifyPostData, convertRequestHeader } from './../shim'
import { DEF_CONST } from './../enum'
import { isFunction, isNode, debugFn } from './../utils'
import { getTimeout } from './../process'

const createAxios = (option, runtime) => {
  option = option || {}

  const instance = axios.create()

  instance.interceptors.request.use(
    (config) => {
      if (isNode) {
        delete config.headers.host
        delete config.headers['accept-encoding']
      }

      config._runtime = runtime
      config._version = pkg.version
      if (config.method.toUpperCase() === DEF_CONST.method.POST) {
        config.data = stringifyPostData(config.data, option, config, runtime)
      }

      debugFn(option, config)
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  instance.interceptors.response.use((response) => {
    let res = response.data
    if (isFunction(option.onSuccess)) {
      res =
        option.onSuccess({
          url: response.config.url,
          method: response.config.method,
          status: response.status,
          config: {
            headers: response.config.headers
          },
          data: res
        }) || res
    }
    return res
  })

  return async function (method, url, data, config) {
    data = data || {}
    config = config || {}

    if (isFunction(option.onRequest)) {
      const newArgs = option.onRequest({ data, method, url, config })
      if (newArgs) {
        url = newArgs.url || url
        data = newArgs.data || data
        method = newArgs.method || method
        config = newArgs.config || config
      }
    }

    const requestData = await appendRequestData(data, method, option, config, runtime)
    const requestHead = await convertRequestHeader(method, option, config, runtime)
    const requestUrl = convertRequestURL(url, requestData, method, option, config, runtime)

    const params = {
      url: requestUrl,
      method,
      timeout: getTimeout(option, config),
      headers: requestHead,
      transformResponse: config.transformResponse,
      adapter: option.adapter,
      withCredentials: config.withCredentials === undefined ? true : config.withCredentials
    }

    if (method === DEF_CONST.method.POST) {
      params.data = requestData
    } else {
      setPreload(requestUrl, option, config, runtime)
      const cache = await getPreload(requestUrl, option, config, runtime)
      if (cache) {
        return Promise.resolve(cache)
      }
    }

    return new Promise((resolve, reject) => {
      instance(params)
        .then(resolve)
        .catch((err) => {
          if (!isNode) {
            reject(err)
            return
          }

          if (config.nodeRetry === false) {
            err.status = 504
            reject(err)
            return
          }

          instance(params)
            .then(resolve)
            .catch((err) => {
              err.status = 504
              reject(err)
            })
        })
    })
  }
}

export default createAxios
